/* =============================================
   PRODUCT COMPARE SYSTEM
   ============================================= */

(function () {
  'use strict';

  const MAX_COMPARE = 3;
  const STORAGE_KEY = 'compare_products';

  function getCompareList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch { return []; }
  }

  function saveCompareList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateUI();
  }

  function addToCompare(productId, productUrl, productTitle, productImage, productPrice) {
    const list = getCompareList();
    if (list.length >= MAX_COMPARE) {
      if (window.showToast) window.showToast('En fazla 3 urun karsilastirabilirsiniz', 'error');
      return;
    }
    if (list.find(p => p.id === productId)) return;

    list.push({ id: productId, url: productUrl, title: productTitle, image: productImage, price: productPrice });
    saveCompareList(list);
  }

  function removeFromCompare(productId) {
    const list = getCompareList().filter(p => p.id !== productId);
    saveCompareList(list);
  }

  function clearCompare() {
    saveCompareList([]);
  }

  function updateUI() {
    const list = getCompareList();
    const bar = document.getElementById('compare-bar');
    if (!bar) return;

    if (list.length === 0) {
      bar.classList.remove('visible');
      return;
    }

    bar.classList.add('visible');

    const items = bar.querySelector('.compare-bar-items');
    items.innerHTML = list.map(p => `
      <div class="compare-bar-item">
        <img src="${p.image}" alt="${p.title}" width="48" height="48">
        <button class="compare-bar-remove" data-remove="${p.id}" aria-label="Kaldir">&times;</button>
      </div>
    `).join('');

    const countEl = bar.querySelector('.compare-bar-count');
    if (countEl) countEl.textContent = `${list.length}/${MAX_COMPARE}`;

    /* Remove handlers */
    items.querySelectorAll('[data-remove]').forEach(btn => {
      btn.addEventListener('click', () => removeFromCompare(btn.dataset.remove));
    });
  }

  /* Delegate checkbox clicks */
  document.addEventListener('change', (e) => {
    const cb = e.target.closest('.compare-checkbox');
    if (!cb) return;

    const card = cb.closest('.product-card');
    if (!card) return;

    if (cb.checked) {
      addToCompare(
        card.dataset.productId,
        card.querySelector('a')?.href || '',
        card.querySelector('.product-card-title a')?.textContent || '',
        card.querySelector('.product-card-img-primary')?.src || '',
        card.querySelector('.product-card-current-price')?.textContent || ''
      );
    } else {
      removeFromCompare(card.dataset.productId);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const clearBtn = document.querySelector('.compare-bar-clear');
    if (clearBtn) clearBtn.addEventListener('click', clearCompare);

    updateUI();
  });

  window.CompareSystem = { addToCompare, removeFromCompare, clearCompare, getCompareList };
})();
